import React from "react";

function NotFoundPage() {
  //write code here

  return <p>Not Found Page</p>;
}

export default NotFoundPage;
